if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');

        const formData = new FormData(this.form);
        const payload = {}
        formData.forEach((value, key) => payload[key] = value)

        delete payload.id
        delete payload.quantity

        const bundleKey = crypto.randomUUID()
        let bundleDiscountAmount, bundleDiscountType, bundleMax

        const bundleItems = Array.from(document.querySelectorAll('.js-bundle-items .js-submit-check:checked:not(:disabled)')).map(input => {
          bundleDiscountType = input.closest('.js-bundle-items').dataset.discountType
          bundleDiscountAmount = input.closest('.js-bundle-items').dataset.discountValue
          bundleMax = input.closest('.js-bundle-items').dataset.maxUsage
          return {
            id: input.closest('product-form-alt').querySelector('[name="id"]').value,
            quantity: 1,
            properties: {
              _parent_id: input.dataset.parentId,
              _bundle_key: bundleKey,
              _bundle_type: 'child',
              _discount_type: bundleDiscountType,
              _discount_amount: bundleDiscountAmount,
              _bundle_max: bundleMax
            }
          }
        })

        const upsellItems = Array.from(document.querySelectorAll('.js-pdp-discount-upsells .js-submit-check:checked:not(:disabled)')).map(input => {
          return {
            id: input.closest('product-form-alt').querySelector('[name="id"]').value,
            quantity: 1,
            properties: {
              _parent_id: input.dataset.parentId
            }
          }
        })

        var items = [
          {
            id: formData.get('id'),
            quantity: formData.get('quantity'),
            properties: Object.assign(bundleItems.length > 0 ? {
              _bundle_key: bundleKey,
              _bundle_type: 'parent',
              _discount_type: bundleDiscountType,
              _bundle_max: bundleMax,
              _discount_amount: bundleDiscountAmount
            } : {})
          }
        ]

        if (this.cart) {
          payload['sections'] = this.cart.getSectionsToRender().map((section) => section.id)

          payload['sections_url'] = window.location.pathname
          this.cart.setActiveElement(document.activeElement);
        }

        items = [...items, ...upsellItems, ...bundleItems]

        payload['items'] = items

        config.body = JSON.stringify(payload);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
